<template>
  <div class="col-span-12 mt-8">
    <div class="intro-y flex items-center h-10">
      <h2 class="text-lg font-medium truncate mr-5">Welcome {{user.firstName}} {{user.lastName}}!</h2>
      <a href="" class="ml-auto flex text-theme-1 dark:text-theme-10">
        <RefreshCcwIcon class="w-4 h-4 mr-3" /> Reload Data
      </a>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5">
            <div class="flex">
              <ShoppingCartIcon class="report-box__icon text-theme-10" />
              <div class="ml-auto">
<!--                <Tippy-->
<!--                    tag="div"-->
<!--                    class="report-box__indicator bg-theme-9 cursor-pointer"-->
<!--                    content="33% Higher than last month"-->
<!--                >-->
<!--                  33% <ChevronUpIcon class="w-4 h-4" />-->
<!--                </Tippy>-->
              </div>
            </div>
            <div class="text-3xl font-bold leading-8 mt-6">{{getWorkshopCompleted()}}</div>
            <div class="text-base text-gray-600 mt-1">
              Workshops Completed
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5">
            <div class="flex">
              <CreditCardIcon class="report-box__icon text-theme-11" />
              <div class="ml-auto">
<!--                <Tippy-->
<!--                    tag="div"-->
<!--                    class="report-box__indicator bg-theme-6 cursor-pointer"-->
<!--                    content="2% Lower than last month"-->
<!--                >-->
<!--                  2% <ChevronDownIcon class="w-4 h-4" />-->
<!--                </Tippy>-->
              </div>
            </div>
            <div class="text-3xl font-bold leading-8 mt-6">BDT {{ getTotalEarning() }}</div>
            <div class="text-base text-gray-600 mt-1">Total Earned</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5">
            <div class="flex">
              <MonitorIcon class="report-box__icon text-theme-12" />
              <div class="ml-auto">
<!--                <Tippy-->
<!--                    tag="div"-->
<!--                    class="report-box__indicator bg-theme-9 cursor-pointer"-->
<!--                    content="12% Higher than last month"-->
<!--                >-->
<!--                  12% <ChevronUpIcon class="w-4 h-4" />-->
<!--                </Tippy>-->
              </div>
            </div>
            <div class="text-3xl font-bold leading-8 mt-6">BDT {{ getTotalEarning() }}</div>
            <div class="text-base text-gray-600 mt-1">Pending Payment</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
        <div class="report-box zoom-in">
          <div class="box p-5">
            <div class="flex">
              <UserIcon class="report-box__icon text-theme-9" />
              <div class="ml-auto">
<!--                <Tippy-->
<!--                    tag="div"-->
<!--                    class="report-box__indicator bg-theme-9 cursor-pointer"-->
<!--                    content="22% Higher than last month"-->
<!--                >-->
<!--                  22% <ChevronUpIcon class="w-4 h-4" />-->
<!--                </Tippy>-->
              </div>
            </div>
            <div class="text-3xl font-bold leading-8 mt-6">{{ getPaidUsers() }}</div>
            <div class="text-base text-gray-600 mt-1">
              Total Paid
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "user"],
  data() {
    return {

    }
  },
  methods: {
    getTotalEarning() {
      let sum = 0
      this.data.forEach(n => {
        sum += (n.info.amount - n.info.expense) * n.info.share
      })
      return sum
    },
    getPaidUsers() {
      let sum = 0
      this.data.forEach(o => {sum += o.info.paid})
      return sum
    },
    getWorkshopCompleted() {
      return this.data.length
    }
  }
}
</script>
